function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
var P9Main = function P9Main(_ref) {
  var page = _ref.page;
  var thisPage = 9;
  return /*#__PURE__*/React.createElement(React.Fragment, null, [0, 1, 2].map(function (x) {
    return /*#__PURE__*/React.createElement(Row, {
      nr: x,
      page: page,
      thisPage: thisPage,
      key: "p9".concat(x)
    });
  }));
};
export default P9Main;
var Row = function Row(_ref2) {
  var nr = _ref2.nr,
    page = _ref2.page,
    thisPage = _ref2.thisPage;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $(".p9-row__".concat(nr)).addClass("p9-row__".concat(nr, "--active"));
      }, 3500 + nr * 1000)]);
    } else {
      $(".p9-row__".concat(nr)).removeClass("p9-row__".concat(nr, "--active"));
    }
  }, [page]);
  var icon = {
    0: 'long-island-icon-1@3x.png',
    1: 'long-island-icon-2@3x.png',
    2: 'long-island-icon-3@3x.png'
  };
  var txt = {
    0: 'supports-local-business-and-our-economy@3x.png',
    1: 'curtails-illegal-dumping-and-mining@3x.png',
    2: 'protects-our-drinking-water@3x.png'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p9-row p9-row__".concat(nr)
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p9/long-island-chip-bg-copy@3x.png",
    className: "p9-row__bg"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p9/mobile-long-island-chip-bg-copy@3x.png",
    className: "p9-row__bg-mobile"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p9/".concat(icon[nr]),
    className: "p9-row__i".concat(nr)
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p9/".concat(txt[nr]),
    className: "p9-row__t".concat(nr)
  }));
};